import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Es la autorización previa para ejecutar en uno o varios predios localizados en suelo rural y suburbano, la creación de espacios públicos y privados, y la ejecución de obras para vías públicas que permitan destinar los predios resultantes a los usos permitidos por el Plan de Ordenamiento Territorial, los instrumentos que lo desarrollen y complementen y la normatividad ambiental aplicable a esta clase de suelo. Estas licencias se podrán otorgar acreditando la autoprestación de servicios públicos, con la obtención de los permisos, autorizaciones y concesiones respectivas otorgadas por las autoridades competentes. También se entiende que hay parcelación de predios rurales cuando se trate de unidades habitacionales en predios indivisos que presenten dimensiones, cerramientos, accesos u otras características similares a las de una urbanización, pero con intensidades y densidades propias del suelo rural que se destinen a vivienda campestre. ")

import LicenceItem from "./LicenceItem.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LicenceItem, { title: 'Licencia de parcelación' }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})